<template>
  <div class="w-full pb-2">
    <div
      class="flex flex-col lg:flex-row lg:justify-between lg:items-center w-full"
    >
      <div class="w-full flex justify-start items-start gap-[11px]">
        <button
          v-if="hasPermission('Orders_View')"
          :class="[
            'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
            {
              'border-b-2 border-[#2463EB] text-[#2463EB]':
                activeTabProp === 'posting',
              'text-[#96a0b5]': activeTabProp !== 'posting',
            },
          ]"
          @click="switchTab('posting')"
        >
          Posting List
        </button>
        <button
          :class="[
            'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
            {
              'border-b-2 border-[#2463EB] text-[#2463EB]':
                activeTabProp === 'methods',
              'text-[#96a0b5]': activeTabProp !== 'methods',
            },
          ]"
          @click="switchTab('methods')"
        >
          Payment Methods
        </button>
        <button
          v-if="hasPermission('Inventory_Reconcile_Stock_View')"
          :class="[
            'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
            {
              'border-b-2 border-[#2463EB] text-[#2463EB]':
                activeTabProp === 'notify',
              'text-[#96a0b5]': activeTabProp !== 'notify',
            },
          ]"
          @click="switchTab('notify')"
        >
          Payment Notifications
        </button>
      </div>
      <div
        class="md:w-full flex justify-start lg:justify-end mt-[16px] xl:mt-0"
      >
        <div v-if="activeTabProp === 'posting'">
          <div class="flex gap-[10px]">
            <button
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
              @click="viewFilter"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filter
            </button>
            <button
              @click="viewAdd"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
            >
              <span class="feather icon-plus text-white"></span> Post A Payment
            </button>
          </div>
        </div>
        <div v-if="activeTabProp === 'methods'">
          <div class="flex gap-[10px]">
            <button
              @click="viewMethodFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button
              @click="viewMethodAdd"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
            >
              <span class="feather icon-plus text-white"></span> New Payment
              Method
            </button>
          </div>
        </div>
        <div v-if="activeTabProp === 'notify'">
          <div class="flex gap-[10px]">
            <button
              @click="filterView"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button
              @click="markRead"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
            >
              Mark As Read
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";
export default {
  components: {},
  props: [
    "hasPermission",
    "activeTabProp",
    "viewFilter",
    "toggleProductFilter",
    "viewFilter",
    "viewAdd",
  ],
  data: () => ({
    isBusy: false,
    isModalVisible: false,
  }),
  methods: {
    viewMethodAdd() {
      bus.$emit("viewAdd");
    },
    viewMethodFilter() {
      bus.$emit("viewFilter");
    },
    markRead() {
      bus.$emit("markRead");
    },
    filterView() {
      bus.$emit("filterView");
    },
    switchTab(tab) {
      this.$emit("switchTab", tab);
    },
    newOrder() {
      this.isModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = "auto";
    },
  },
};
</script>
